import React, { useState } from 'react'
import api from '../services/api'

interface Props {
  onClose: () => void
  onSalvo: (cliente: any) => void
}

const UFS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO']

export default function NovoClienteModal({ onClose, onSalvo }: Props) {
  const [aba, setAba] = useState<'dados' | 'endereco'>('dados')
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')

  // Dados principais
  const [cnpjCpf, setCnpjCpf]     = useState('')
  const [natureza, setNatureza]   = useState('J')
  const [nome, setNome]           = useState('')
  const [fantasia, setFantasia]   = useState('')
  const [contribIcms, setContrib] = useState('N')
  const [ie, setIe]               = useState('')
  const [uf, setUf]               = useState('')
  const [im, setIm]               = useState('')
  const [tipoEmp, setTipoEmp]     = useState(' ')

  // Endereço
  const [logradouro, setLogradouro] = useState('')
  const [numero, setNumero]         = useState('')
  const [complemento, setCompl]     = useState('')
  const [bairro, setBairro]         = useState('')
  const [cep, setCep]               = useState('')
  const [cidade, setCidade]         = useState('')
  const [endUf, setEndUf]           = useState('')
  const [tel1, setTel1]             = useState('')
  const [tel2, setTel2]             = useState('')
  const [email, setEmail]           = useState('')
  const [obs, setObs]               = useState('')

  function formatarDoc(v: string) {
    const n = v.replace(/\D/g, '')
    if (natureza === 'J') {
      return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')
    }
    return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4')
  }

  function handleDocChange(v: string) {
    const n = v.replace(/\D/g, '').slice(0, natureza === 'J' ? 14 : 11)
    setCnpjCpf(n)
  }

  async function salvar() {
    setErro('')
    if (!cnpjCpf || !nome) {
      setErro('CNPJ/CPF e Nome/Razão Social são obrigatórios.')
      setAba('dados')
      return
    }
    setSalvando(true)
    try {
      const payload = {
        cli_mat: cnpjCpf,
        cli_fj: natureza,
        cli_nom: nome,
        cli_fan: fantasia || nome,
        cli_contri: contribIcms,
        cli_ins: ie,
        cli_est: uf,
        cli_insmun: im,
        cli_tipemp: tipoEmp,
        end_logradouro: logradouro,
        end_numero: numero,
        end_complemento: complemento,
        end_bairro: bairro,
        end_cep: cep,
        end_cidade: cidade,
        end_uf: endUf || uf,
        end_tel: tel1 + (tel2 ? ` / ${tel2}` : ''),
        end_email: email,
        end_obs: obs,
      }
      const r = await api.post('/erp/clientes', payload)
      onSalvo(r.data)
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar cliente.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">

        {/* Header */}
        <div className="modal-header">
          <h2>Cadastro de Cliente</h2>
          <button className="modal-fechar" onClick={onClose}>✕</button>
        </div>

        {/* Abas */}
        <div className="modal-abas">
          <button className={`modal-aba${aba === 'dados' ? ' modal-aba--ativa' : ''}`} onClick={() => setAba('dados')}>
            Dados Principais
          </button>
          <button className={`modal-aba${aba === 'endereco' ? ' modal-aba--ativa' : ''}`} onClick={() => setAba('endereco')}>
            Endereços
          </button>
        </div>

        <div className="modal-corpo">

          {/* ── Aba Dados Principais ── */}
          {aba === 'dados' && (
            <div>
              <div className="form-grid-cad">

                <div className="field-cad col2">
                  <label>CNPJ / CPF</label>
                  <input
                    value={formatarDoc(cnpjCpf)}
                    onChange={e => handleDocChange(e.target.value)}
                    placeholder={natureza === 'J' ? '00.000.000/0000-00' : '000.000.000-00'}
                    autoFocus
                  />
                </div>

                <div className="field-cad">
                  <label>Natureza</label>
                  <select value={natureza} onChange={e => { setNatureza(e.target.value); setCnpjCpf('') }}>
                    <option value="J">Jurídica</option>
                    <option value="F">Física</option>
                    <option value="E">Estrangeiro</option>
                  </select>
                </div>

                <div className="field-cad">
                  <label>Tipo de Cadastro</label>
                  <select defaultValue="C">
                    <option value="C">Cliente</option>
                    <option value="F">Fornecedor</option>
                    <option value="A">Ambos</option>
                  </select>
                </div>

                <div className="field-cad col4">
                  <label>Nome / Razão Social <span className="obrig">*</span></label>
                  <input value={nome} onChange={e => setNome(e.target.value.toUpperCase())} placeholder="Nome completo ou razão social" />
                </div>

                <div className="field-cad col4">
                  <label>Fantasia</label>
                  <input value={fantasia} onChange={e => setFantasia(e.target.value.toUpperCase())} placeholder="Nome fantasia (opcional)" />
                </div>

                <div className="field-cad col2">
                  <label>Contribuinte ICMS</label>
                  <select value={contribIcms} onChange={e => setContrib(e.target.value)}>
                    <option value="N">Não Contribuinte</option>
                    <option value="S">Contribuinte</option>
                    <option value="C">Comércio</option>
                    <option value="I">Isento</option>
                  </select>
                </div>

                <div className="field-cad col2">
                  <label>Inscrição Estadual</label>
                  <input value={ie} onChange={e => setIe(e.target.value)} placeholder="IE" />
                </div>

                <div className="field-cad">
                  <label>Estado (UF)</label>
                  <select value={uf} onChange={e => setUf(e.target.value)}>
                    <option value="">--</option>
                    {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>

                <div className="field-cad col2">
                  <label>Inscrição Municipal</label>
                  <input value={im} onChange={e => setIm(e.target.value)} placeholder="IM" />
                </div>

                <div className="field-cad">
                  <label>Tipo de Empresa</label>
                  <select value={tipoEmp} onChange={e => setTipoEmp(e.target.value)}>
                    <option value=" ">Geral</option>
                    <option value="M">ME</option>
                    <option value="E">EPP</option>
                    <option value="S">Simples Nacional</option>
                  </select>
                </div>

              </div>
            </div>
          )}

          {/* ── Aba Endereços ── */}
          {aba === 'endereco' && (
            <div>
              <div className="form-grid-cad">

                <div className="field-cad col3">
                  <label>Endereço / Logradouro</label>
                  <input value={logradouro} onChange={e => setLogradouro(e.target.value)} placeholder="Rua, Av, etc." />
                </div>

                <div className="field-cad">
                  <label>Número</label>
                  <input value={numero} onChange={e => setNumero(e.target.value)} placeholder="Nro" />
                </div>

                <div className="field-cad col2">
                  <label>Complemento</label>
                  <input value={complemento} onChange={e => setCompl(e.target.value)} placeholder="Sala, apto..." />
                </div>

                <div className="field-cad col2">
                  <label>Bairro</label>
                  <input value={bairro} onChange={e => setBairro(e.target.value)} />
                </div>

                <div className="field-cad">
                  <label>CEP</label>
                  <input value={cep} onChange={e => setCep(e.target.value.replace(/\D/g,'').replace(/(\d{5})(\d)/,'$1-$2'))} placeholder="00000-000" maxLength={9} />
                </div>

                <div className="field-cad col2">
                  <label>Cidade</label>
                  <input value={cidade} onChange={e => setCidade(e.target.value)} />
                </div>

                <div className="field-cad">
                  <label>Estado (UF)</label>
                  <select value={endUf} onChange={e => setEndUf(e.target.value)}>
                    <option value="">--</option>
                    {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>

                <div className="field-cad col2">
                  <label>Telefone / Cel</label>
                  <input value={tel1} onChange={e => setTel1(e.target.value)} placeholder="(00) 00000-0000" />
                </div>

                <div className="field-cad col2">
                  <label>Telefone 2 / Caixa Postal</label>
                  <input value={tel2} onChange={e => setTel2(e.target.value)} placeholder="(00) 0000-0000" />
                </div>

                <div className="field-cad col4">
                  <label>E-mail</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@exemplo.com" />
                </div>

                <div className="field-cad col4">
                  <label>Observação</label>
                  <input value={obs} onChange={e => setObs(e.target.value)} />
                </div>

              </div>
            </div>
          )}

          {erro && <div className="login-error" style={{ marginTop: '1rem' }}>{erro}</div>}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : 'Salvar Cliente'}
          </button>
        </div>

      </div>
    </div>
  )
}
